export function findByPath(
  obj: object,
  path: string,
  defaultValue: string,
  suffix: string,
) {
  let result: any = obj;
  for (const field of path.split('.')) {
    if (!result) {
      return defaultValue;
    }
    result = result[field];
  }

  return `${result}${suffix}`;
}
